import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center mb-4" }

import elementsIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import BackupStatusBar from '../backupStatusBar/backupStatusBar.vue';
import CoordinatorUpTime from './coordinatorUpTime.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'coordinatorStatusBar',
  setup(__props) {

const osService = useOsService();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BackupStatusBar, {
      ref: "isAnyBackupInstalled",
      "data-testid": _unref(elementsIds).coordinatorStatusBar.backupCoordinator
    }, null, 8, ["data-testid"]),
    (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(CoordinatorUpTime, {
          key: 0,
          class: "mt-0.5",
          "data-testid": _unref(elementsIds).coordinatorStatusBar.coordinatorUpTime
        }, null, 8, ["data-testid"]))
      : _createCommentVNode("", true)
  ]))
}
}

})